// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"26":"c2295333","451":"a821848c"}[chunkId] + ".css";
};